import { render, staticRenderFns } from "./CorporativeList.vue?vue&type=template&id=73d15fcb&scoped=true"
import script from "./CorporativeList.vue?vue&type=script&lang=js"
export * from "./CorporativeList.vue?vue&type=script&lang=js"
import style0 from "./CorporativeList.vue?vue&type=style&index=0&id=73d15fcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d15fcb",
  null
  
)

export default component.exports